// src/hooks/useAllGames.js
import { useEffect, useState } from "react";
import {
  loadAllGames,
  getAllGamesSync,
  isAllGamesLoaded,
} from "../data/allGames";

export function useAllGames() {
  // Seed with whatever we already have (BASE_GAMES or full cache)
  const [games, setGames] = useState(getAllGamesSync());
  // If already loaded, don't show a loading state again
  const [loading, setLoading] = useState(!isAllGamesLoaded());

  useEffect(() => {
    let cancelled = false;

    loadAllGames().then((loaded) => {
      if (cancelled) return;
      setGames(loaded);
      setLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  return { games, loading };
}
